/**
 * @date: 2021-12-13
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 */
import React, {useEffect, useState} from "react";
import {getQueryParams, handleHttpResponseAcceptAuthError} from "../utils/http-helpers";
import makeStyles from "@mui/styles/makeStyles";
import {ApiUrl, PortalUrl} from "../utils/portal-urls";
import {Alert, AlertTitle, alpha, Backdrop, Button, CircularProgress, Container} from "@mui/material";
import ShowMessage from "../utils/show-message";


const useStyles = makeStyles((theme) => ({
    formRoot: {
        width: '100%',
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 350,
    },
    formInput: {
        margin: theme.spacing(1),
        minWidth: '100%',
    },
    loginButton: {
        minHeight: 56,
        width: 300,
        // minWidth: '100%',
        fontSize: 20,
        fontWeight: 'bold',
        textTransform: 'none',
        marginBottom: 10
    },
    forgotPwdButton: {
        textTransform: 'none'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    testAlignLeft: {
        textAlign: 'left'
    },
    signInButtonWrapper: {
        whiteSpace: 'nowrap', marginBottom: 15
    },
    signInButton: {
        width: 150, height: 55, marginRight: 15, whiteSpace: 'nowrap'
    },
    // signInButton: {
    //     width: 125, height: 45, marginRight: 10, whiteSpace: 'nowrap'
    // },
    signOutButton: {
        display: 'block', marginBottom: 10, whiteSpace: 'nowrap'
    }
}));

const TokenStatusType = {
    Valid: 1,
    Invalid: 0,
    Unknown: -1
};

export default function SignUp (props) {
    const queryParams = getQueryParams();
    const token = queryParams.token || null;
    console.log(token);

    const [tokenStatus, setTokenStatus] = useState(TokenStatusType.Unknown);
    const [msg, setMsg] = useState({});
    const [loading, setLoading] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);

    const classes = useStyles();

    const [form, setForm] = useState({});


    useEffect(() => {
        if (!token){
            setMsg({error: `Missing activation token. Please contact MaxMD support 1-201-963-0005.`});
        } else {
            validateToken(token);
        }
    }, [token]);

    const validateToken = async (token) => {
        fetch(ApiUrl.Activation.Token.SignUp.Verify.getPath(token))
            .then(handleHttpResponseAcceptAuthError)
            .catch( (err) => {
                setLoading(null);
                setTokenStatus(TokenStatusType.Invalid);
                if (err){
                    setMsg({error: `Invalid Token. ${err}`});
                }
                return false;
            }).then ( (res) => {
            if (res){
                setTokenStatus(TokenStatusType.Valid);
            }
        });
    }

    let googleAuthorizeUrl = `${PortalUrl.SignInWithGoogle}?token=${token}`;

    console.log('tokenStatus', tokenStatus);
    return (
        <Container className='auth-container' maxWidth='xs' >
            <div className='logo-wrapper'>
                <img src={require('../images/dt-logo.png')?.default}/>
            </div>
            {/*<br/>*/}
            {/*<img src={require('../images/MaxMD-logo.png')}/>*/}
            {/*<br/><br/>*/}
            <h3 className='auth-title'>Sign up to the Directory Admin Portal with</h3>

            <ShowMessage msg={msg} />


            {queryParams && queryParams.error &&
            <Alert severity="warning" className={classes.testAlignLeft}>
                <AlertTitle> <strong>{queryParams.error} {queryParams.errorTitle || ""}</strong> </AlertTitle>
                {queryParams.errorDescription || ""}
            </Alert>
            }

            {tokenStatus === TokenStatusType.Invalid && <div>

            </div>}
            {tokenStatus !== TokenStatusType.Invalid && <div>
                <div className='or-bar' >
                    {/*<span>Sign in with</span>*/}
                </div>


                <div className={classes.signInButtonWrapper}>
                    <Button className={classes.signInButton} variant='outlined' color='primary' href={googleAuthorizeUrl}>
                        <img src={require('../images/google-logo.svg')?.default} width={30}/> &nbsp; Google
                    </Button>
                </div>
                {/*<div className={classes.signInButtonWrapper}>*/}
                {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={idmeAuthorizeUrl}>*/}
                {/*        <img src={require('../images/IDme-Logo.png')} height={22}/>*/}
                {/*    </Button>*/}
                {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={googleAuthorizeUrl}>*/}
                {/*        <img src={require('../images/google-logo.svg')} width={22}/> &nbsp; Google*/}
                {/*    </Button>*/}
                {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={linkedInAuthorizeUrl}>*/}
                {/*        <img src={require('../images/linkedin-logo.svg')} width={19}/> &nbsp; LinkedIn*/}
                {/*    </Button>*/}

                {/*</div>*/}
            </div>}



            <Backdrop className={classes.backdrop} open={tokenStatus === TokenStatusType.Unknown} >
                <CircularProgress color={"inherit"} />
                Verifying token ...
            </Backdrop>

        </Container>

    );




}
